import { Icon, Td, Tr } from "@chakra-ui/react";
import MenuCustomsClearence from "components/Menu/MenuCustomsClearence";
import GlobalContext from "context/GlobalContext";
import { useContext } from "react";
import { FaRegEdit } from "react-icons/fa";

const TBodyAuthFormatSRT = ({ data, status_outputForm, isCdi = false }) => {
  const { idItemSRT, setiIdItemSRT, isOpen, setIsOpen, numItemSRT, setNumdItemSRT } = useContext(GlobalContext);
  console.log({ data })
  status_outputForm = data.status_entryForm
  let isEditBlocked = status_outputForm === 'AUTORIZADO'
  if (isCdi) {
    isEditBlocked = false
  }
  const handleClick = (e) => {
    e.preventDefault();
    setiIdItemSRT(data?.id);
    setNumdItemSRT(data?.item);
    setIsOpen(true);
  }

  return (
    <Tr>
      <Td className="text-center">{data?.item ? data?.item : "N/A"}</Td>
      <Td className="text-center">{data?.description_product ? data?.description_product : "N/A"}</Td>
      <Td className="text-center">{data?.quantity ? data?.quantity : "N/A"}</Td>
      <Td className="text-center">{data?.unit_measurement ? data?.unit_measurement : "N/A"}</Td>
      <Td className="text-center">{data?.srt_serial ? data?.srt_serial : "N/A"}</Td>
      <Td className="text-center">{data?.srt_color ? data?.srt_color : "N/A"}</Td>
      <Td className="text-center">{data?.status_srt ? data?.status_srt : "N/A"}</Td>
      <Td className="text-center">{data?.srt_special_description ? data?.srt_special_description : "N/A"}</Td>      
      <Td className="text-center">
        <button
          onClick={isEditBlocked ? undefined : handleClick}
          disabled={isEditBlocked}
          style={{
            cursor: isEditBlocked ? 'not-allowed' : 'pointer',
            opacity: isEditBlocked ? 0.5 : 1,
            border: 'none',
            background: 'transparent'
          }}
          title={isEditBlocked ? 'No se puede editar en estado AUTORIZADO' : 'Editar'}
        >
          <Icon as={FaRegEdit} boxSize={6} color={'#212529'} pr={1} />
        </button>
      </Td>
    </Tr>
  );
};

export default TBodyAuthFormatSRT;
